import { render, staticRenderFns } from "./SidebarNotifications.vue?vue&type=template&id=38560976&"
import script from "./SidebarNotifications.vue?vue&type=script&lang=js&"
export * from "./SidebarNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports